import { ElementRef, Injector, NgModule, Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OSharedModule } from '../../shared';
import { AppMenuService, MenuGroup } from '../../services';
import { InputConverter } from '../../decorators';
// import { OAppSidenavComponent } from './o-app-sidenav.component';
import { OAppSidenavMenuItemModule } from './o-app-sidenav-menu-item.component';

export const DEFAULT_INPUTS_O_APP_SIDENAV_MENU_GROUP = [
  'menuGroup : menu-group',
  'sidenavOpened : sidenav-opened'
];

export const DEFAULT_OUTPUTS_O_APP_SIDENAV_MENU_GROUP = [];


export class OAppSidenavMenuGroupComponent {
  // implements OnInit
  public static DEFAULT_INPUTS_O_APP_SIDENAV_MENU_GROUP = DEFAULT_INPUTS_O_APP_SIDENAV_MENU_GROUP;
  public static DEFAULT_OUTPUTS_O_APP_SIDENAV_MENU_GROUP = DEFAULT_OUTPUTS_O_APP_SIDENAV_MENU_GROUP;

  protected appMenuService: AppMenuService;

  public menuGroup: MenuGroup;

  @InputConverter()
  sidenavOpened: boolean = true;

  constructor(
    protected injector: Injector,
    protected elRef: ElementRef
    //   // @Optional() @Inject(forwardRef(() => OAppSidenavComponent)) protected sidenavComp: OAppSidenavComponent,
  ) {
    this.appMenuService = this.injector.get(AppMenuService);
  }

  // ngOnInit() {

  // }

  onClick() {
    this.menuGroup.opened = !this.menuGroup.opened;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-app-sidenav-menu-group',
  inputs: DEFAULT_INPUTS_O_APP_SIDENAV_MENU_GROUP,
  outputs: DEFAULT_OUTPUTS_O_APP_SIDENAV_MENU_GROUP,
  template: `
    <button md-button class="application-sidenav-item application-sidenav-menugroup" [class.active]="menuGroup.opened" fxLayout="column"
      fxFill (click)="onClick()">
      <div  fxLayout="row" fxLayoutAlign="start center" fxFill>
        <md-icon *ngIf="menuGroup.icon">{{ menuGroup.icon }}</md-icon>
        <h3 *ngIf="sidenavOpened">{{ menuGroup.name | oTranslate }}</h3>
        <span *ngIf="sidenavOpened" class="example-fill-remaining-space"></span>
        <md-icon *ngIf="sidenavOpened" class="application-sidenav-menugroup-arrow">keyboard_arrow_right</md-icon>
      </div>
    </button>

    <div class="application-sidenav-menugroup-items-container">
      <ul class="application-sidenav-menugroup-ul">
        <o-app-sidenav-menu-item *ngFor="let menuItem of menuGroup.items" [sidenav-opened]="sidenavOpened" [menu-item]="menuItem"
          [menu-item-type]="appMenuService.getMenuItemType(menuItem)">
        </o-app-sidenav-menu-item>
      </ul>
    </div>
  `,
  styles: [`

  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: ElementRef, },
];
}


export class OAppSidenavMenuGroupModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OSharedModule,
    OAppSidenavMenuItemModule
  ],
  declarations: [
    OAppSidenavMenuGroupComponent
  ],
  exports: [OAppSidenavMenuGroupComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
